import { Popover, PopoverButton, PopoverPanel } from "@headlessui/react";
import { useState } from "react";

import InfoIcon from "~/icons/InfoIcon";
import { brandConfig } from "~/configs/brandConfigs";
import { Brand } from "~/entities/brandEntities";

import styles from "./ChangePhonePopover.module.css";

const ChangePhonePopover = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Popover className="relative">
      <PopoverButton
        as="div"
        className={styles.popoverButton}
        onMouseEnter={() => setIsOpen(true)}
        onMouseLeave={() => setIsOpen(false)}
      >
        <InfoIcon />
      </PopoverButton>
      {isOpen && (
        <PopoverPanel
          static
          as="div"
          anchor="bottom"
          className={styles.popoverPanel}
          onMouseEnter={() => setIsOpen(true)}
          onMouseLeave={() => setIsOpen(false)}
        >
          <div className={styles.arrow}></div>
          {brandConfig.Brand === Brand.BURGER_FUEL
            ? "Please contact us directly at info@burgerfuel.co.nz to change your phone number"
            : "Please contact us directly to change your phone number"}
        </PopoverPanel>
      )}
    </Popover>
  );
};

export default ChangePhonePopover;
